'use strict';

import {
    addButtonStyling,
    addExportBtns,
    addSelectedCompanyHandler,
    companyGuard,
    fnErrorMsg,
    getSelectedCompany,
    getSelectedCompanyForUser,
    pjaxRedirect,
    popupCenterDual,
    toggleDatatable
} from "../jquery-functions-library";
import {element_exists, redesignDataTablesHeader} from "../functions";
import {fnPaySlipSendReminder} from "./pay_slips-send-reminder";
import {fnPaySlipApproval} from "./pay_slips-approve";

const fnRegisterPayslipBtn = (table) => {
    const btnOpen = '.btn-open-pay-slip' + ':not(.first-approver):not(.next-approver)';
    const btnOpenFirstApprover = '.btn-open-pay-slip' + '.first-approver';
    const btnOpenSecondApprover = '.btn-open-pay-slip' + '.next-approver';

    $(document).off('click', btnOpen);
    $(document).on('click', btnOpen, function (e) {
        e.preventDefault();

        const data = JSON.parse(table.row($(this).parents('tr')).data().payslip);
        if (!data.read_by_client && isClient()) {
            markPayslipAsRead(data.id, table);
        }

        popupCenterDual('pay-slips/' + data.id + '/get', data.filename, window.innerWidth / 2, window.innerHeight / 1.2);
    });

    $(document).off('click', btnOpenFirstApprover);
    $(document).on('click', btnOpenFirstApprover, function (e) {
        e.preventDefault();

        const data = JSON.parse(table.row($(this).parents('tr')).data().payslip);
        if (!data.read_by_first_approver && isClient()) {
            markPayslipAsReadByFirstApprover(data.id, table);
        }

        popupCenterDual('pay-slips/' + data.id + '/get', data.filename, window.innerWidth / 2, window.innerHeight / 1.2);
    });

    $(document).off('click', btnOpenSecondApprover);
    $(document).on('click', btnOpenSecondApprover, function (e) {
        e.preventDefault();

        const data = JSON.parse(table.row($(this).parents('tr')).data().payslip);
        if (!data.read_by_next_approver && isClient()) {
            markPayslipAsReadBySecondApprover(data.id, table);
        }

        popupCenterDual('pay-slips/' + data.id + '/get', data.filename, window.innerWidth / 2, window.innerHeight / 1.2);
    });

    
};

const isClient = () => {
    return $('body').attr('data-company') !== undefined;
};

const markPayslipAsRead = (id, table) => {
    $.ajax({
        method: 'POST',
        url: '/salary/pay-slips/mark-as-read',
        data: {id},
        success: function (response) {
            table.ajax.reload(null, false);
        },
        error: function (response) {
        }
    });
}

const markPayslipAsReadByFirstApprover = (id, table) => {
    $.ajax({
        method: 'POST',
        url: '/salary/pay-slips/mark-as-read-by-first-approver',
        data: {id},
        success: function (response) {
            table.ajax.reload(null, false);
        },
        error: function (response) {
        }
    });
}


const markPayslipAsReadBySecondApprover = (id, table) => {
    $.ajax({
        method: 'POST',
        url: '/salary/pay-slips/mark-as-read-by-next-approver',
        data: {id},
        success: function (response) {
            table.ajax.reload(null, false);
        },
        error: function (response) {
        }
    });
}



export var fnPayrollOptions = function () {
    const optionsCol = '.payroll-options-col';
    const companySelect = '#selected_company';

    if (!element_exists('#filter_payrolls')) return false;

    const $groupSelector = $('#filter_payrolls');

    if (typeof $groupSelector.data('select2') === 'undefined') {
        $groupSelector.select2();
    }

    $groupSelector.on('select2:select', function () {
        loadCompanyBlueprints();
    })

    function loadEmployees(context) {
        const val = $(context).val();

        if (val === 'extra') {
            let selectedCompany = getSelectedCompany();

            let url;
            if (selectedCompany !== undefined) {
                url = `/employees/${selectedCompany}`;
            } else {
                url = `/employees/for-current-company`;
            }
            $('#createPayrollFormEmployeeIdsGroup').remove();

            $.ajax(url, {
                method: 'GET',
                success(response) {
                    const selectHtml = `
                            <div class="form-group viia-form-group viia-select2-group" id="createPayrollFormEmployeeIdsGroup">
                                <label for="createPayrollFormEmployeeIds" class="viia-form-filter-label">Medarbejdere</label>
                                <select name="employeeIds" id="createPayrollFormEmployeeIds" class="form-control select2" multiple="multiple">
                                    ${response.map(employee => (`<option value="${employee.id}">${employee.first_name} ${employee.last_name} </option>`)).join("\n")}
                                </select>
                            </div>
                        `;
                    $('#create-payroll-form').append($(selectHtml));

                    const $createPayrollFormEmployeeIds = $('#createPayrollFormEmployeeIds');
                    $createPayrollFormEmployeeIds.select2();
                },
                error() {
                    toastr.error(allLangFiles.forms.generic_error);
                }
            });
        } else {
            $('#createPayrollFormEmployeeIdsGroup').remove();
        }
    }

    $(document).off('click', '#btn-create-payroll').on('click', '#btn-create-payroll', function () {
        const $createPayrollFormType = $('#createPayrollFormType');
        if (!$createPayrollFormType.data('select2')) {
            $createPayrollFormType.select2();
        }

        const $createPayrollFormMonth = $('#createPayrollFormMonth');
        if (!$createPayrollFormMonth.data('select2')) {
            $createPayrollFormMonth.select2();
        }

        const $createPayrollFormYear = $('#createPayrollFormYear');
        if (!$createPayrollFormYear.data('select2')) {
            $createPayrollFormYear.select2();
        }

        $('#modal-create-payroll').modal('show');

        $createPayrollFormType.off('select2:select').on('select2:select', function () {
            loadEmployees(this);
        });
        loadEmployees($createPayrollFormType);
    });

    if (!element_exists(optionsCol)) return false;

    let orgTable = $('#datatable-existing-payrolls').parent().html();

    loadCompanyBlueprints();

    addSelectedCompanyHandler(loadCompanyBlueprints);

    function loadCompanyBlueprints(e) {
        $('.table-responsive').html(orgTable);

        const company_id = getSelectedCompany();

        if (company_id === 'default') {
            $('#btn-create-payroll').hide();
        } else {
            $('#btn-create-payroll').show();
        }

        //Load table
        const tableName = '#datatable-existing-payrolls';

        let showTable = true;

        if (!companyGuard()) {
            $('.payroll-filters').show();
            $('#submitCreatePayrollForm').off('click').on('click', function () {
                const $form = $('#create-payroll-form');

                const type = $form.find($('#createPayrollFormType')).val();
                const month = $form.find($('#createPayrollFormMonth')).val();
                const year = $form.find($('#createPayrollFormYear')).val();
                const employeeIds = $form.find($('#createPayrollFormEmployeeIds')).val();

                $.ajax('/salary/payrolls/store', {
                    data: {
                        type,
                        month,
                        year,
                        employeeIds
                    },
                    method: 'POST',
                    success(response) {
                        $('#modal-create-payroll').modal('hide');

                        $(tableName).DataTable().ajax.reload();

                        if (typeof response.success !== 'undefined') {
                            toastr.success(response.success)
                        } else if (typeof response.info !== 'undefined') {
                            toastr.info(response.info)
                        }
                        if(typeof response.url !== 'undefined'){
                            pjaxRedirect(response.url);
                        }
                    },
                    error() {
                        toastr.error(allLangFiles.forms.generic_error);
                    }
                })
            });

            $(tableName).css('width', '100%');

            const columns = [
                {data: 'id'},
                {data: 'year'},
                {
                    data: 'month', render(data, type) {
                        if (type === 'display') {
                            return allLangFiles.salary.sheets.months[data];
                        }

                        return data;
                    }
                },
                {
                    data: function (data) {
                        var type = allLangFiles.salary.excel.types[data.type];
                        return type !== undefined ? type : '-';
                    }
                },
                {
                    data: 'num_of_employees', render(data) {
                        if (Number(data) > 1 || Number(data) === 0) {
                            return `${data} ${allLangFiles.salary.sheets.employees}`;
                        }

                        return `${data} ${allLangFiles.salary.sheets.employee}`;
                    }
                },
                {
                    data: 'approved_by_name', render(data) {
                        if (data === null) {
                            return `<span class="text-danger">${allLangFiles.payrolls.existing.not_approved}</span>`
                        }

                        return `<span class="text-success">${data}</span>`;
                    }
                },
                {
                    data: 'payslip_approved_by_all_approvers', render(data) {
                        if (data === null) {
                            return `<span class="text-danger">${allLangFiles.payrolls.existing.not_approved}</span>`
                        }

                        return `<span class="text-success">${data}</span>`;
                    }
                },             
                {data: 'payslip_actions'},
                {data: 'actions'},
            ];

            /*Rules for filling the columns*/
            const columnDefs = [
                {visible: false, targets: 0},
                {className: "dt-right payslip-actions", width: 310, targets: [7]},
                {visible: $(tableName).data('has-salary-payrolls-permission'), className: "dt-right", width: 100, targets: [8]},
            ];

            /*Important otherwise table misaligned*/
            let urlTable = `/salary/payrolls/table/${getSelectedCompanyForUser()}?filter=${$groupSelector.val()}`;

            const table = $(tableName).DataTable({

                language: allLangFiles.datatables,
                rowId: 'id',
                ajax: {
                    url: urlTable,
                    dataSrc: function (json) {


                        return json.data;
                    },
                },
                columns: columns,
                columnDefs: columnDefs,
                scrollX: true,
                lengthMenu: [10, 25, 50, 75, 100],
                order: [[1, 'desc'], [2, 'desc']],
                initComplete: function (settings, json) {


                    toggleDatatable(showTable, tableName);


                    table.columns.adjust().draw();
                },
                drawCallback() {
                    fnRegisterPayslipBtn(table);
                    fnPaySlipSendReminder(tableName);
                    fnPaySlipApproval(tableName);

                    $(`${tableName} [data-toggle="popover"]:not([data-only-title])`).popover({
                        delay: 0
                    });

                    const popOverTemplate = `
                        <div class="popover" role="tooltip">
                            <div class="popover-arrow"></div>
                            <h3 class="popover-title only-title"></h3>
                            <div class="popover-content hidden"></div>
                        </div>
                    `;

                    $(`${tableName} [data-toggle="popover"][data-only-title]`).popover({
                        template: popOverTemplate,
                        delay: 500
                    });

                    $(`${tableName} .btn-reject-pay-slip`).popover({
                        template: popOverTemplate,
                        delay: 500,
                        trigger: 'hover',
                        placement: 'bottom',
                        title: allLangFiles['pay-slips'].reject
                    });

                    $('.btn-upload-pay-slip:not(.btn-upload-final-pay-slip, .btn-no-popover)').off('hover').popover({
                        trigger: 'hover',
                        title: allLangFiles['pay-slips'].upload,
                        placement: 'bottom',
                        template: popOverTemplate,
                        delay: 500
                    });
                    $('.btn-upload-final-pay-slip').off('hover').popover({
                        trigger: 'hover',
                        title: allLangFiles['pay-slips'].upload_final,
                        placement: 'bottom',
                        template: popOverTemplate,
                        delay: 500
                    });
                }
            });

        //checks if the user has permission to download payslips log, if they do, adds the button to export the payslips log.
        //if they don't, adds the default export buttons to the table.
        if ($('#datatable-existing-payrolls').data().hasPayslipsLogPermission == 1) {
            new $.fn.dataTable.Buttons($(tableName).DataTable(), {
                buttons: [
                    {
                        extend: 'pdf',
                        text: allLangFiles.payslips_log.entries.page_header + ' (pdf)',
                        exportOptions: {
                            columns: ':visible'
                        },
                        action: function (e, dt, node, config) {
                            const companyId = getSelectedCompanyForUser();
                            const url = `/payslips-log/download/${companyId}`;

                            getRequestDownload(url);
                        }
                    },
                
                ]
            });

            addButtonStyling($(tableName).DataTable());
        } else {
            addExportBtns($(tableName));
        }
        
        redesignDataTablesHeader(tableName);

        } else {
            $(optionsCol).html('');
            $(tableName).parents('.table-responsive').addClass('hidden');
            $('.payroll-filters').hide();
        }
    }
};

function getRequestDownload(url) {
    window.location = url;
}